<template>
    <div>
        <modal :show.sync="internalShowModal">
            <template slot="header">
                <h5 class="modal-title">Ingrese su código personal</h5>
            </template>
            <div>
                <div class="row">
                    <div class="col-md-12 text-center">
                        <form autocomplete="off">
                            <div>
                                <!-- Evita interferir en el guardar/cambiar contraseña en chrome para el usuario logueado -->
                                <base-input class="userName" value="pinuser" autocomplete="off" hidden/>
                            </div>
                            <div>
                                <pincode-input v-model="pinEntry" ref="pincode-input" secure v-if="internalShowModal" autocomplete="off" :length="6"/>
                            </div>
                        </form>
                    </div>
                </div>
                <div class="row mt-4 mb-2">
                    <div class="col-md-12 text-center">
                        <base-button type="danger" size="md" @click="validatePinEntry">Validar</base-button>
                    </div>
                </div>
            </div>
        </modal>
    </div>
</template>

<script>
import PincodeInput from 'vue-pincode-input';
import notificationHelpers from "@/helpers/notificationHelpers";
import generalHelpers from "@/helpers/generalHelpers";
import axiosHelpers from "@/helpers/axiosHelpers";

export default {
    name: "PinValidation",
    components: {
        "pincode-input": PincodeInput
    },
    props: {
        showModal: {
            type: Boolean,
            default: false,
            description: "Show modal"
        },
        accumulationMethodTypeID: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            usePaymentPin: false,
            pin: '',
            pinEntry: '',
            validateButtonPressed: false,
            AccumulationMethodTypeID: this.accumulationMethodTypeID
        };
    },
    watch: {
        showModal(val) {
            if(val) {
                // Al abrir el modal limpio sus datos
                this.cleanModal();
            }
        }
    },
    computed: {
        internalShowModal: {
            get() {
                return this.showModal;
            },
            set(val) {
                this.$emit("update:showModal", val);
            }
        }
    },
    methods: {
        getAccumulationMethodTypeID(context){
            if(context.AccumulationMethodTypeID == 0){
                context.AccumulationMethodTypeID=context.$store.getters.PERSONAL_DATA_UPDATE_ATTEMPTS_METHOD_TYPE_ID;
            }
        },
        getUsePinAccount(context) {
            axiosHelpers.axiosPost("Account/GetUsePinAccount", {}, context, function(data) {
                context.usePaymentPin = data.ResponseVM.UsePin;
                context.pin = data.ResponseVM.Pin;
                context.$emit("loadUsePaymentPin", context.usePaymentPin);
            });
        },
        AddNewAttemptByAccount(context){
                 let req = {
                    AccumulationMethodTypeID: context.AccumulationMethodTypeID,
                    SecurityMethodID: context.$store.getters.PIN_SECURITY_METHOD_ID,
                    Reason: 'PIN Incorrecto'
                };

                axiosHelpers.axiosPost("DoubleFactorSecurity/AddNewAttemptByAccount", req, context, function(data) {
                    notificationHelpers.showError("Error", "El pin ingresado no es correcto", context);
                    context.$emit("validPin", false);
                });
        },
        validatePinEntry() {
            // Para checkear si el modal se cerró sin presionar el botón 'validar'
            this.validateButtonPressed = true;
            // Cierro modal
            this.internalShowModal = false;
            var pinEntryMD5 = generalHelpers.convertStringToMD5(this.pinEntry);

            if (this.pin == null || this.pin == undefined) {
                notificationHelpers.showError("Error", "Pin inexistente", this);
                this.$emit("validPin", false);
                return;
            }

            if (pinEntryMD5.toUpperCase() != this.pin.toUpperCase()) {   
                this.AddNewAttemptByAccount(this);             
                return;
            }
            
            this.$emit("validPin", true);
        },
        cleanModal() {            
            if(this.$refs["pincode-input"] != undefined) {
                this.$refs["pincode-input"].letters.forEach(l => {
                    l.value = '';
                });
            }

            this.pinEntry = '';
            this.validateButtonPressed = false;
        }
    },
    beforeMount: function() {
        this.getUsePinAccount(this);
        this.getAccumulationMethodTypeID(this);
    }
}
</script>